import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { IOrderDocumentModel } from '@dss-libs/portal/type/portal-types';
import { AutoHideScrollbarDirective, TooltipIfTruncatedDirective } from '@dss-libs/shared/ui/common-directives';
import { TranslocoDirective } from '@jsverse/transloco';
import { FileSizePipe } from '@dss-libs/shared/ui/common-pipes';
import { TranslocoDecimalPipe } from '@jsverse/transloco-locale';

@Component({
  selector: 'dss-libs-feature-attachments-card',
  imports: [
    TranslocoDirective,
    FileSizePipe,
    MatIcon,
    MatTooltip,
    AutoHideScrollbarDirective,
    TranslocoDecimalPipe,
    TooltipIfTruncatedDirective,
  ],
  templateUrl: './attachments-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentsCardComponent {
  readonly documents = input.required<IOrderDocumentModel[]>();
  readonly userName = input.required<string>();
}
